// Check if a value is a browser file.
const isFile = (value) => {
  return value instanceof File || value instanceof Blob;
};

// Append nested values to FormData for Laravel.
export const appendFormData = (formData, key, value) => {
  if (value === undefined || value === null) {
    return;
  }

  if (isFile(value)) {
    formData.append(key, value);
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item, index) => {
      if (isFile(item)) {
        formData.append(`${key}[]`, item);
        return;
      }

      appendFormData(formData, `${key}[${index}]`, item);
    });

    return;
  }

  if (typeof value === 'object') {
    Object.entries(value).forEach(([nestedKey, nestedValue]) => {
      appendFormData(formData, `${key}[${nestedKey}]`, nestedValue);
    });

    return;
  }

  formData.append(key, value);
};

// Convert normal object to FormData.
export const createFormData = (payload = {}) => {
  const formData = new FormData();

  Object.entries(payload).forEach(([key, value]) => {
    appendFormData(formData, key, value);
  });

  return formData;
};

export default createFormData;